export const SUPERCUBE_CUBEMAP_PATH = 'https://d1amgc8mf7b4xu.cloudfront.net/base/';
